export default function PHP_sqlstate() {
  return (
    <div>
      <h1>PHP_sqlstate</h1>
    </div>
  );
}
